// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__10I1Y","col":"styles_col__4GC5M"};